import animateScrollTo from 'animated-scroll-to'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import React from 'react'

import { TextLH } from 'styles/components/typography'

import { SSMobileMenu, SSMobileMenuItem } from './styles'

const SWIPER_SETTINGS = {
  slidesPerView: 'auto',
  spaceBetween: 30,
  freeMode: true,
}

const Swiper = dynamic(() => import('react-id-swiper'))

const SSpyMobileHandler = ({ items, sectionsRefs, sceneActiveIndex }) => {
  const [swiper, updateSwiper] = React.useState(null)
  const [activeIndex, setActiveIndex] = React.useState(-1)
  const [pageIsScrolling, setPageIsScrolling] = React.useState(false)
  const scrollToElement = React.useRef()

  const offCenteredSlides = React.useCallback(() => {
    if (swiper) {
      swiper.params.centeredSlides = false
      swiper.update()
    }
  }, [swiper])

  const scrollToHandler = React.useCallback(
    (element, index) => {
      if (!pageIsScrolling) {
        scrollToElement.current = element.current
        setActiveIndex(index)
        setPageIsScrolling(true)
      }
    },
    [pageIsScrolling],
  )

  React.useEffect(() => {
    if (swiper) {
      swiper.on('transitionStart', offCenteredSlides)
    }

    return () => {
      if (swiper) {
        swiper.off('transitionStart', offCenteredSlides)
      }
    }
  }, [swiper, offCenteredSlides])

  React.useEffect(() => {
    if (swiper && !pageIsScrolling) {
      const slidesLength = swiper.slides.length - 1

      if (sceneActiveIndex > 0 && sceneActiveIndex < slidesLength) {
        swiper.params.centeredSlides = true
        swiper.update()
      } else {
        swiper.params.centeredSlides = false
        swiper.update()
      }

      swiper.slideTo(sceneActiveIndex)
    }
  }, [swiper, sceneActiveIndex, pageIsScrolling])

  React.useEffect(() => {
    if (swiper && pageIsScrolling) {
      const slidesLength = swiper.slides.length - 1

      if (activeIndex > 0 && activeIndex < slidesLength) {
        swiper.params.centeredSlides = true
        swiper.update()
      } else {
        swiper.params.centeredSlides = false
        swiper.update()
      }

      swiper.slideTo(activeIndex)
    }
  }, [swiper, activeIndex, pageIsScrolling])

  React.useEffect(() => {
    if (pageIsScrolling) {
      animateScrollTo(scrollToElement.current, {
        speed: 300,
        verticalOffset: -100,
        cancelOnUserAction: false,
      }).then(() => {
        setActiveIndex(-1)
        setPageIsScrolling(false)
      })
    }
  }, [pageIsScrolling])

  return (
    <SSMobileMenu>
      <Swiper {...SWIPER_SETTINGS} getSwiper={updateSwiper}>
        {items.map((value, key) => (
          <SSMobileMenuItem
            isActive={
              (sceneActiveIndex === key && !pageIsScrolling) ||
              (activeIndex === key && pageIsScrolling)
            }
            key={key}
            idx={key}
            length={items.length}
            onClick={() => scrollToHandler(sectionsRefs[key], key)}
          >
            <TextLH
              dangerouslySetInnerHTML={{
                __html: value.menuTitle || value.title,
              }}
            />
          </SSMobileMenuItem>
        ))}
      </Swiper>
    </SSMobileMenu>
  )
}

SSpyMobileHandler.propTypes = {
  items: PropTypes.array.isRequired,
  sectionsRefs: PropTypes.array.isRequired,
  swiperRef: PropTypes.object.isRequired,
  sceneActiveIndex: PropTypes.number,
}

SSpyMobileHandler.defaultProps = {
  sceneActiveIndex: 0,
}

export default SSpyMobileHandler
